function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import { Button, Typography } from 'onboarding-components';
import * as React from 'react';
import produce from 'immer';
import { SetupGuideContext, Step } from 'common/onboarding/immersive-onboarding/types';
import { IMMERSIVE_ASSETS } from 'common/onboarding/immersive-onboarding/assets';
import { track, TrackingEvent, TrackingProperty } from 'common/onboarding/immersive-onboarding/tracking';
import { ApiClient } from 'common/onboarding/immersive-onboarding/api-client';
import { useTranslation } from 'common/i18n/hooks';
import { FooterActionBar } from './footer-action-bar';
import styles from './welcome-v2.module.styl';

// eslint-disable-next-line react/destructuring-assignment
const WelcomeCTA = _ref => {
  let {
    image,
    title,
    subtitle,
    cta,
    iconSrc
  } = _ref;
  const {
    onClick,
    ctaText
  } = cta;
  return <>
      <div className={styles.welcomeCta} style={{
      backgroundImage: "url(".concat(image, ")"),
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat"
    }}>
        <img src={iconSrc} className={styles.welcomeCtaIcon} />
        <div className={styles.welcomeCtaContent}>
          <Typography variant='headingXs' className={styles.noMargin} data-sentry-element="Typography" data-sentry-source-file="welcome-v2-default.tsx">
            {title}
          </Typography>
          <Typography variant='bodySm' data-sentry-element="Typography" data-sentry-source-file="welcome-v2-default.tsx">{subtitle}</Typography>
          <div>
            <Button variant='solid' size='medium' onClick={onClick} data-sentry-element="Button" data-sentry-source-file="welcome-v2-default.tsx">
              {ctaText}
            </Button>
          </div>
        </div>
      </div>
    </>;
};
export const WelcomeV2Default = () => {
  const {
    t
  } = useTranslation();
  const {
    setStep,
    setupGuideInfo,
    setSetupGuideInfo
  } = React.useContext(SetupGuideContext);
  return <div className={styles.welcomeContent} data-sentry-component="WelcomeV2Default" data-sentry-source-file="welcome-v2-default.tsx">
      <Typography variant='headingSm' className={styles.noMargin} data-sentry-element="Typography" data-sentry-source-file="welcome-v2-default.tsx">
        {t("onboarding.welcome.choose-start")}
      </Typography>
      <Typography className={styles.subTitle} variant='bodySm' data-sentry-element="Typography" data-sentry-source-file="welcome-v2-default.tsx">
        {t("onboarding.welcome.mixpanel-will-help")}
      </Typography>
      <div className={styles.welcomeCtas}>
        <WelcomeCTA image={IMMERSIVE_ASSETS.personalizeStepGradient} title={t("onboarding.welcome.new-to-analytics")} subtitle={t("onboarding.welcome.quick-setup")} cta={{
        ctaText: t("onboarding.welcome.personalize-setup"),
        onClick: () => {
          // TODO (Sonya) - distill this to one function
          const updatedStepsCompleted = produce(setupGuideInfo.stepsCompleted, draft => {
            draft.add(Step.Welcome);
          });
          ApiClient.updateCompleted(setupGuideInfo.projectId, updatedStepsCompleted);
          setSetupGuideInfo(_objectSpread(_objectSpread({}, setupGuideInfo), {}, {
            stepsCompleted: updatedStepsCompleted
          }));
          setStep(Step.Events);
          track(TrackingEvent.WelcomePersonalizeSetupClick, {
            [TrackingProperty.CurrentStep]: Step.Welcome,
            [TrackingProperty.Phase2]: true
          });
        }
      }} iconSrc={IMMERSIVE_ASSETS.clipboardCheckboxes} data-sentry-element="WelcomeCTA" data-sentry-source-file="welcome-v2-default.tsx" />
        <WelcomeCTA image={IMMERSIVE_ASSETS.connectDataGradient} title={t("onboarding.welcome.already-use-cdp")} subtitle={t("onboarding.welcome.example-cdps")} cta={{
        ctaText: t("onboarding.welcome.connect-data"),
        onClick: () => {
          const updatedStepsCompleted = produce(setupGuideInfo.stepsCompleted, draft => {
            draft.add(Step.Welcome);
          });
          ApiClient.updateCompleted(setupGuideInfo.projectId, updatedStepsCompleted);
          setSetupGuideInfo(_objectSpread(_objectSpread({}, setupGuideInfo), {}, {
            stepsCompleted: updatedStepsCompleted
          }));
          setStep(Step.Implement);
          track(TrackingEvent.WelcomeConnectDataClick, {
            [TrackingProperty.CurrentStep]: Step.Welcome,
            [TrackingProperty.Phase2]: true
          });
        }
      }} iconSrc={IMMERSIVE_ASSETS.ligthningBolt} data-sentry-element="WelcomeCTA" data-sentry-source-file="welcome-v2-default.tsx" />
      </div>
      <div className={styles.footerActionBarWrapper}>
        <FooterActionBar data-sentry-element="FooterActionBar" data-sentry-source-file="welcome-v2-default.tsx" />
      </div>
    </div>;
};